import Transform from './Base';

export default class UsersTransform extends Transform {
  /**
   * Method used to transform a fetched user.
   *
   * @param user The fetched user profile.
   *
   * @returns {Object} The transformed user profile.
   */
  static fetch(user) {
    return {
      email: user.email,
      id: user._id,
      login: user.username,
      name: user.display_name,
    };
  }
}
